
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0072C8","fill-rule":"evenodd","d":"M24 6C14.059 6 6 14.059 6 24s8.059 18 18 18 18-8.059 18-18S33.941 6 24 6zm0 32.994c-8.281 0-14.994-6.713-14.994-14.994 0-8.281 6.713-14.994 14.994-14.994 8.281 0 14.994 6.713 14.994 14.994 0 8.281-6.713 14.994-14.994 14.994zm-1.494-5.4h2.988v-12.6h-2.988v12.6zm0-15.534h3.006V15h-3.024l.018 3.06z","clip-rule":"evenodd"}})])
          )
        }
      }
    